import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { screenLog } from '../store/actions/common-action';
import { useDispatch } from 'react-redux';

const useScreenLogger = (user) => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!location?.pathname || !user?.clientId) return;
    logScreen();
  }, [location.pathname, user?.clientId]);

  const logScreen = async () => {
    const ip = await getUserIP();

    const payload = {
      accessTime: new Date().toISOString(),
      screen: location.pathname,
      url: window.location.href,
      userAgent: navigator.userAgent,
      userId: user?.clientId ?? '',
      investorTypeId: user?.investorTypeId ?? '',
      userIpAddress: ip,
      browser: getBrowserName(),
    };

    dispatch(screenLog(payload));
  };
};

// Optional helper (keeps hook clean)
const getBrowserName = () => {
  const ua = navigator.userAgent;

  if (ua.includes('Chrome')) return 'Chrome';
  if (ua.includes('Firefox')) return 'Firefox';
  if (ua.includes('Safari')) return 'Safari';
  if (ua.includes('Edge')) return 'Edge';

  return ua;
};

export default useScreenLogger;

const getUserIP = async () => {
  try {
    const res = await fetch('https://api.ipify.org?format=json');
    const data = await res.json();
    return data?.ip;
  } catch {
    return '';
  }
};
